import { useQuery } from '@tanstack/react-query';
import { storesApi } from '@/lib/api';
import { queryKeys } from '@/lib/query-client';

export function useStores() {
  return useQuery({
    queryKey: queryKeys.stores,
    queryFn: async () => {
      const response = await storesApi.list();
      return response.data;
    },
  });
}

export function useStore(id: string | undefined) {
  return useQuery({
    queryKey: queryKeys.store(id || ''),
    queryFn: async () => {
      const response = await storesApi.getById(id!);
      return response.data;
    },
    enabled: !!id,
  });
}
